import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger);

window.addEventListener('load', function () {  
	if( document.querySelector('.slide-right')) {

    const slideRights = document.querySelectorAll('.slide-right');

    slideRights.forEach((slideRight) => {

       gsap.fromTo(slideRight,
        {
          xPercent:-45,
          rotation:20,
        },
        {
          xPercent:0,
          rotation:0,
          scrollTrigger: {
            trigger: slideRight,
            start:"top 100%",
            end:"bottom 25%",
            scrub: true,
            ease: CustomEase.create("custom", "M0,0 C0.7,0 0.2,1 1,1 ")
          }
        }
      );

    });

  }
}, false);